import React from 'react';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import MuiCard from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import TimeAgo from 'react-timeago'
import { styled } from "@mui/material/styles";
import { AnimatePresence, motion } from "framer-motion";
import { useMutation } from '@apollo/client';
import CardContent from './CardContent';
import {
  ADD_RECENT_MUTATION,
} from '../../graph/UserGraph';
import Stack from '@mui/material/Stack';

const StyledCard = styled(MuiCard)(({ theme }) => ({
  minWidth: "17rem",
  maxWidth: "17rem",
  minHeight: "17rem",
  maxHeight: "17rem",
  borderRadius: theme.spacing(1),
  boxShadow: `0 0 10px rgba(0, 0, 0, 0.15)`,
  margin: theme.spacing(1),
  display: `flex`,
  flexDirection: `column`,
  backgroundColor: theme.palette.primary.dark,
  justifyContent: `space-between`,
  "img": {
    width: "80%"
  }
}))

export default function Card(props) {
  const { data: record, favouritesData } = props
  const cardData = record.report || record
  let userID = localStorage.getItem("userID")
  // Actions available on card - Add to rect views, remove from recents
  const [addRecent, addRecentResult] = useMutation(ADD_RECENT_MUTATION);

  function addToRecents(report) {
    addRecent({
      variables: { userID: userID, reportID: record.id }
    });

  }

  const timeAgo = <TimeAgo date={record.visitTime} formatter={(value = 0, unit = 'hour', suffix = 'ago') => `${value} ${unit} ${suffix}`} locale="en-US" timestyle="twitter" />

  return (
    <AnimatePresence>
      <motion.div
        key="search-content"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <StyledCard
        // {...rest}

        >
          <CardContent
            cardData={cardData}
            favouritesData={favouritesData}

          />

          <CardActions>
            <Stack direction="row" justifyContent={`space-between`} spacing={2}>
              <Button component={Link} size="small" href={`/app/${cardData.__typename}/${cardData.title}/${cardData.id}`} target="_blank" onClick={() => addToRecents(cardData)} >
                Details
              </Button>              {cardData.prod_url != undefined && cardData.prod_url.length > 0 ?
                <Button
                  component={Link}
                  size="small"
                  href={cardData.prod_url}
                  target="_blank">
                  Visit
                </Button>
                :
                <Button component={Link} size="small" disabled>Visit</Button>
              }
            </Stack>
          </CardActions>
          {
            record.visitTime != undefined || record.visitTime ?
              (<Box sx={{ pr: 3 }} >
                <Typography
                  align="right"
                  color="textSecondary"
                  gutterBottom
                  variant="caption"
                  display="block"

                >
                  {record.visitTime != undefined ? timeAgo : null}
                </Typography>
              </Box>) : null}

        </StyledCard>
      </motion.div>
    </AnimatePresence>
  );
}


